import React, { useState } from "react";
import FormDialog from "../../../../components/Dialog/FormDialog";
import Loader from "../../../../components/Loader";
import { useUserProfileForAdmin } from "../../../../reactQuery/users";
import UserProfileContent from "./UserProfileContent";
import ChangePassword from "./ChangePassword";

function UserProfile({ open=false, userId, handleClose }) {
  const { isLoading, profileData } = useUserProfileForAdmin(userId);
  const [changePassword, setChangePassword] = useState(false);

  return (
    <FormDialog
      open={open}
      handleClose={handleClose}
      title={"Profile"}
      btnTitle={"Update"}
      width={"932px"}
      fullWidth={true}>
      {changePassword && (
        <FormDialog
          open={changePassword}
          handleClose={() => setChangePassword(false)}
          title={"Change Password"}
          btnTitle={"Update"}>
          <ChangePassword
            userId={userId}
            onClose={() => setChangePassword(false)}
          />
        </FormDialog>
      )}

      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <UserProfileContent
          profileData={profileData}
          userId={userId}
          handleClose={handleClose}
          onChangePassword={() => setChangePassword(true)}
        />
      )}
    </FormDialog>
  );
}

export default React.memo(UserProfile);
